import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter, Instagram, Users, MailIcon } from 'lucide-react';
import '../styles/Footer.css';
import logo from '../assets/logo.png';



const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About', path: '/about' },
      { name: 'Services', path: '/services' },
      { name: 'Industries', path: '/industries' }
    ],
    resources: [
      { name: 'Resources', path: '/resources' },
    ],
    careers: [
      { name: 'Join Us', path: '/careers', icon: <Users size={16} /> },
    ]
  };

  const socialLinks = [
    { icon: <Linkedin size={20} />, url: 'https://www.linkedin.com/company/nishis-consulting/', name: 'LinkedIn' },
    { icon: <MailIcon size={20} />, url: 'mailto:letsconnect@kosmozconsulting.com', name: 'Mail' }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="logo">
              <img
                src={logo}
                alt="Kosmoz Logo"
                className="logo-image"
              />
            </Link>
            <p className="footer-tagline">
              Building Smarter. Launching Faster.
            </p>
            <div className="footer-social">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="social-link"
                  aria-label={social.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Resources</h4>
              <ul>
                {footerLinks.resources.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Careers</h4>
              <ul>
                {footerLinks.careers.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="footer-link-with-icon">
                      <span>{link.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Get Started</h4>
              <p>Ready to accelerate your growth?</p>
              <Link to="/contact" className="btn btn-primary footer-cta">
                Book a Consultation
              </Link>
              {/* <a href="mailto:hello@kosmoz.io" className="footer-email">
                <Mail size={16} />
                hello@kosmoz.io
              </a> */}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 Kosmoz Consulting. All rights reserved.</p>
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;